import React from 'react';
import styled from 'styled-components';
import { declOfNum, dataLayerPush } from '@ertelecom/ui-react/components/helpers';
import StyledButton from '@ertelecom/ui-react/components/buttons/styledButton';
import Icon from '@ertelecom/ui-react/components/icon';
import { COLORS } from '@ertelecom/ui-react/assets/js/constants';
import ThemedChannels from './themed';
import { EVENTS } from '~/src/constants/analytics';

const Content = styled.div`
    width: 100%;
    border-radius: 4px;
    padding: 15px 27px;
    background: #fff;
    font-family: 'robotoLight', Arial, Helvetica, sans-serif;
    justify-content: space-between;
    margin-bottom: 20px;
    @media (max-width: 1024px) {
        padding: 20px;
    }
    @media (max-width: 640px) {
        padding: 15px;
        flex-direction: column;
    }
`;
const Block = styled.div`
    @media (max-width: 910px) {
        max-width: 50%;
    }
    @media (max-width: 640px) {
        max-width: 100%;
    }
    @media (max-width: 500px) {
        justify-content: space-between;
    }
`;
const Logo = styled.img`
    width: 74px;
    height: 74px;
    border-radius: 50%;
    margin-right: 15px;
    @media (max-width: 1024px) {
        display: none;
    }
`;
const TextBlock = styled.div`
    flex-direction: column;
    justify-content: center;
    line-height: 24px;
    @media (max-width: 640px) {
        margin-bottom: 20px;
    }
`;
const Title = styled.div`
    font-size: 20px;
    @media (max-width: 500px) {
        font-size: 16px;
    }
`;
const ChannelsCount = styled.div`
    color: ${COLORS.blue};
    cursor: pointer;
    font-size: 16px;
`;
const Caret = styled(Icon)`
    color: ${COLORS.blue};
    margin-left: 8px;
    transform: ${props => props.isOpen ? 'rotate(180deg)' : 'none'};
`;
const Price = styled.div`
    font-size: 32px;
    line-height: 40px;
    align-items: center;
    margin-right: 20px;
`;
const Valute = styled.div`
    font-size: 14px;
    line-height: 18px;
    width: 36px;
    margin-left: 5px;
`;
const Button = styled(StyledButton)`
    min-width: 120px;
    width: auto;
    align-self: center;
    height: 50px;
    padding: 14px 20px;
    cursor: pointer;
    @media (max-width: 500px) {
        padding: 14px;
    }
`;
const ChannelsWrapper = styled.div`
    width: 100%;
    border-top: 1px solid ${COLORS.grey};
    margin-top: 20px;
`;

const channelsText = declOfNum(['канал', 'канала', 'каналов']);

const REQUEST_URL = '/request?productId={id}&productType=100';

const CHANNEL_PACKAGE = 'Пакет каналов';
const SALE_PACKAGE = 'Тариф';

const sendEvent = (action) => {
    dataLayerPush({
        event: EVENTS.UAevent,
        category: 'Domru tv clicked btn',
        action
    });
};

export default class Bundle extends React.Component {
    static defaultProps = {
        bundle: {
            channels: []
        },
    }

    state = {
        isOpen: false
    }

    toggle = () => {
        this.setState(state => ({
            isOpen: !state.isOpen
        }));
    }

    redirect = () => {
        const { bundle, isTariff } = this.props;
        sendEvent(isTariff ? 'go to request' : bundle.title);
    }

    render() {
        const { bundle, isTariff } = this.props;
        const { isOpen } = this.state;

        const channels = isOpen ? <ChannelsWrapper>{bundle.channels.map((theme, key) => <ThemedChannels key={key} theme={theme} />)}</ChannelsWrapper> : null;

        const href = isTariff ? REQUEST_URL.replace('{id}', bundle.id) : bundle.alias;

        const title = isTariff ? SALE_PACKAGE : CHANNEL_PACKAGE;

        return (
            <Content data-test='bundle-content'>
                <Block>
                    {
                        bundle.image && <Logo src={bundle.image} />
                    }
                    <TextBlock>
                        <Title>{title} «{bundle.title}»</Title>
                        <ChannelsCount data-test='channel-count' onClick={this.toggle}>
                            {bundle.channelsCount} {channelsText(bundle.channelsCount)}
                            <Caret isOpen={isOpen} content='\e653' />
                        </ChannelsCount>
                    </TextBlock>
                </Block>
                <Block>
                    <Price data-test='bundle-price'>
                        {bundle.price}
                        <Valute>руб. в мес</Valute>
                    </Price>
                    <Button data-test='button-plug' text='Подключить' onClick={this.redirect} href={href} target='_blank'/>
                </Block>
                {
                    channels
                }
            </Content>
        );
    }
}
